import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConcise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconConcise"><Path d="M3.5 10.5H20.5M20.5 13.5H3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 3.5L12 7L8.5 3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 20.5L12 17L15.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconConcise;
